import { FC, Suspense, lazy } from 'react'
import { Outlet, Routes, Route } from 'react-router-dom'

import SuspenseFallback from '@components/SuspenseFallback'
import Notice from '@components/Notice'

import routePaths from './route-paths'

type ContextType = {
  tableId?: number
  isEditable?: boolean
}

const AppLayout: FC<ContextType> = () => (
  <Suspense fallback={<SuspenseFallback withPadding />}>
    <Outlet />
  </Suspense>
)

const ProjectContainer = lazy(() =>
  import('../features/projects').then(module => ({ default: module.ProjectContainer }))
)

// Fallback component for Not Found route
const NotFound = () => <Notice type="info" title="Not Found" body="Unable to recognize route." className="m" />

export const Router: FC<ContextType> = props => (
  <Suspense fallback={<SuspenseFallback withPadding />}>
    <Routes>
      <Route element={<AppLayout {...props} />}>
        <Route
          path={`/${routePaths.project}/:uuid`}
          element={<ProjectContainer tableId={props.tableId} isEditable={props.isEditable} />}
        />
        <Route
          path={`/${routePaths.project}/:uuid/views/:viewId`}
          element={<ProjectContainer tableId={props.tableId} isEditable={props.isEditable} />}
        />
        {/* 404 fallback */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  </Suspense>
)

export default Router
